import React from 'react';

export default function IconToastSuccess({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6783 6.2652C16.0841 6.63981 16.1094 7.27246 15.7348 7.67829L9.73479 14.1783C9.3699 14.5736 8.75765 14.6094 8.3492 14.2593L4.8492 11.2593C4.42987 10.8998 4.38131 10.2685 4.74073 9.84921C5.10015 9.42989 5.73145 9.38133 6.15078 9.74075L8.91896 12.1135L14.2652 6.32172C14.6398 5.9159 15.2724 5.8906 15.6783 6.2652Z"
        fill="#08A84B"
      />
    </svg>
  );
}
